import { SearchOutlined } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CustomToolbar = () => {
  return (
    <div>
      <div id="toolbar">
        {
          <span className="ql-formats">
            <select className="ql-header" />
          </span>
        }
        <span className="ql-formats">
          <button className="ql-bold" />
          <button className="ql-italic" />
          <button className="ql-underline" />
        </span>
        <span className="ql-formats">
          <button className="ql-strike" />
          <select className="ql-color">
            <option value="red" />
            <option value="green" />
            <option value="blue" />
            <option value="orange" />
            <option value="violet" />
            <option value="#d0d1d2" />
          </select>
        </span>
        {
          <span className="ql-formats">
            <button className="ql-list" value="ordered" />
            <button className="ql-list" value="bullet" />
          </span>
        }
        {
          <span className="ql-formats">
            {/* <button className="ql-link" /> */}
            <button className="ql-image" />
            {/* <button className="ql-video" /> */}
            <button className="ql-gif">GIF</button>
          </span>
        }
        <span className="ql-formats">
          <button className="ql-clean" />
        </span>
      </div>
    </div>
  );
};

const TextEditor = ({ onChange, value, placeholder }) => {
  const quillRef = useRef(null);
  const [gifSearch, setGifSearch] = useState("");
  const [gifs, setGifs] = useState([]);
  const [showGifPicker, setShowGifPicker] = useState(false);
  const TENOR_API_KEY = process.env.REACT_APP_TENOR_API_KEY || '';

  useEffect(() => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;
    quill.getModule("toolbar").addHandler("gif", () => {
      setShowGifPicker(true);
    });
  }, []);
  useEffect(() => {
    setTimeout(() => {
      const editors = document.querySelectorAll(".ql-editor");
      const imgs = Array.from(editors).flatMap((editor) =>
        Array.from(editor.getElementsByTagName("img"))
      );
      Array.from(imgs || []).forEach((img) => {
        img.setAttribute("width", "75");
        img.style.objectFit = "cover";
      });
    }, 100);
  }, []);

  const handleGifSearch = async (e) => {
    e.preventDefault();
    const res = await fetch(
      `https://tenor.googleapis.com/v2/search?q=${gifSearch}&key=${TENOR_API_KEY}&limit=50`
    );
    const data = await res.json();
    setGifs(data.results || []);
  };

  const insertGif = (url) => {
    const quill = quillRef.current?.getEditor();
    quill.focus();
    const range = quill?.getSelection();
    quill?.insertEmbed(range?.index || 0, "image", url);
    setTimeout(() => {
      const editors = document.querySelectorAll(".ql-editor");
      const imgs = Array.from(editors).flatMap((editor) =>
        Array.from(editor.getElementsByTagName("img"))
      );
      Array.from(imgs || []).forEach((img) => {
        img.setAttribute("width", "75");
        img.style.objectFit = "cover";
      });
    }, 100);
    setShowGifPicker(false);
    setGifs([]);
    setGifSearch("");
  };
  return (
    <div className="text-editor">
      <CustomToolbar />
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={{
          toolbar: {
            container: "#toolbar",
            handlers: {
              gif: useCallback(() => setShowGifPicker(true), []),
            },
          },
          clipboard: {
            matchVisual: false,
          },
        }}
        formats={formats}
        placeholder={placeholder}
      />
      {showGifPicker && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: 8,
            padding: 16,
            zIndex: 9999,
            width: "40vw",
            height: "40vh",
            minHeight: 500,
            minWidth: 300,
            boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
          }}
        >
          <div>
            <button
              onClick={() => setShowGifPicker(false)}
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                background: "transparent",
                border: "none",
                fontSize: 16,
                cursor: "pointer",
                zIndex: 1000,
              }}
            >
              X
            </button>
          </div>
          <div style={{ marginTop: 20 }}>
            <TextField
              fullWidth
              id="standard-bare"
              variant="outlined"
              placeholder="GIFs suchen..."
              onChange={(e) => setGifSearch(e.target.value)}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={(e) => {
                      e.preventDefault();
                      handleGifSearch(e);
                    }}
                  >
                    <SearchOutlined />
                  </IconButton>
                ),
              }}
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                window.innerWidth > 1000 ? "repeat(3, 1fr)" : "repeat(1, 1fr)",
              gap: 8,
              maxHeight: "80%",
              minHeight: 300,
              overflowY: "auto",
            }}
          >
            {gifs.map((gif) => (
              <img
                key={gif.id}
                src={gif.media_formats?.tinygif?.url}
                alt="gif"
                style={{ cursor: "pointer" }}
                onClick={() => insertGif(gif.media_formats?.gif?.url)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const formats = [
  "header",
  //   "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "list",
  "bullet",
  "align",
  //   "link",
  "image",
  "style",
  "width",
  //   "video",
];

export default TextEditor;
